import React, {useEffect, useState} from "react";
import {IContratoFilterDto} from "@models/contratos/dto.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {IContrato} from "@models/contratos/contrato.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {_ContratosEndpoints} from "@localization/siteMap/endpoints/_ContratosEndpoints.ts";
import {Grid, IconButton, Paper, Table, TableCell, TableBody,TableContainer, TableHead, TableRow} from "@mui/material";
import {ContratoInfoRow} from "@components/contratos/ContratoInformacao.tsx";
import {DefaultPagination} from "@shared/specialComponents/DefaultPagination.tsx";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {CreateContratoPage} from "@components/contratos/pages/CreateContratoPage.tsx";
import {AddOutlined, FilterAlt} from "@mui/icons-material";

import {useApi} from "@contexts/hooks/api/useApi.ts";

interface ContratosPageProps extends IContratoFilterDto, DefaultPageProps {

}

export const ContratosPage: React.FC<ContratosPageProps> = (props) => {
	const {addPopUp, closePopUp} = useAlert();
	const {Get} = useApi()

	const [contratos, setContratos] = useState<IContrato[]>([]);
	const [pagination, setPagination] = useState<IPagination>({
		page: 0,
		pageSize: 10,
	});

	useEffect(() => {
		if (pagination.page == 0) {
			setPagination({...pagination, page: 1});
			return;
		}

		setPagination(prev => ({...prev, ignoreCache: false, loading: true}))
		Get(_ContratosEndpoints.GetContratos(props, pagination))
			.then((x) => {
				if (x.status == 'Success') {
					setContratos(x.items);
					setPagination(prev => ({...prev, ...x.pagination}));
				}
			}).finally(() => {
			setPagination(prev => ({...prev, ignoreCache: false, loading: false}));
		});
	}, [pagination.page, pagination.ignoreCache == true]);

	return (<DefaultContainer component={Paper}>
		<Grid container justifyContent={'space-between'}>
			<Grid>
				<PermissionableButton permission={['CriarContrato']}
				                      label={'Criar contrato'}
				                      icon={<AddOutlined/>}
				                      onClick={() => {
					                      addPopUp({
						                      title: 'Confecção de contrato',
						                      content: <CreateContratoPage onCreate={() => {
							                      closePopUp()
							                      setPagination({...pagination, page: 0});
						                      }}
						                                                   recursoId={props.recursoIds && props.recursoIds[0]}/>,
						                      size: 'lg',
					                      });
				                      }}
				/>
			</Grid>
			<Grid>
				<IconButton>
					<FilterAlt/>
				</IconButton>
			</Grid>

		</Grid>
		<Grid container>
			<Grid size={12}>
				<DefaultPagination posicao={'top'} pagination={pagination} setPagination={setPagination}/>
			</Grid>
			<TableContainer>
				<Table size={'small'} stickyHeader>
					<TableHead>
						<TableRow>
							<TableCell>Id</TableCell>
							<TableCell>Titulo</TableCell>
							<TableCell>Descrição</TableCell>
							<TableCell>Valor</TableCell>
							<TableCell>Fornecedor</TableCell>
							<TableCell align={'center'}>Mais</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{contratos.map((contrato) => (
							<ContratoInfoRow key={contrato.id} value={contrato}/>
						))}

					</TableBody>
				</Table>
			</TableContainer>
			<Grid size={12}>
				<DefaultPagination posicao={'bottom'} pagination={pagination} setPagination={setPagination}/>
			</Grid>
		</Grid>
	</DefaultContainer>);
};